import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { Router } from '@angular/router';
import { RelatedCompaniesModel } from './related-companies.model';
import { RelatedCompaniesService } from './related-companies.service';
import { RelatedCompaniesFormComponent } from './related-companies-form.component';
import { RelatedCompaniesDeleteComponent } from './related-companies-delete.component';
import { RelatedCompaniesConst } from './const';
import { RelatedCompaniesFormTransactionsComponent } from './related-companies-form-transactions.component';
import { RelatedCompaniesDialogTComponent } from './related-companies-dialog-t.component';
import { consts } from '../../../../consts';
import { Utils } from '../../../../shared/utils';

@Component({
    selector: 'app-related-companies-list',
    templateUrl: './related-companies-list.component.html',
    styleUrls: ['./related-companies-list.component.css'],
    standalone: false
})
export class RelatedCompaniesListComponent implements OnInit {
  ready = false;
  empty: boolean = true;
  headerTable: any[] = RelatedCompaniesConst.headerTable;
  dataSource: RelatedCompaniesModel[] = [];
  constructor(
    public relatedCompaniesService: RelatedCompaniesService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private router: Router,
    protected snackBar: MatSnackBar,
  ) { }

  public ngOnInit() {
    this.relatedCompaniesService.getList().then(
      data => {
        this.dataSource = data;
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  public create(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(RelatedCompaniesFormComponent, {
      width: '500px', maxWidth: '96vw',
      data: { uid: uid },
    });
  }

  public edit(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(RelatedCompaniesFormComponent, {
      width: '500px', maxWidth: '96vw',
      data: { uid: uid },
    })
  }

  public delete(uid: number) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(RelatedCompaniesDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public contribution(uid: number, isContribution: boolean): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const PartnerSelected = this.dataSource.find(x => x.uid === uid);
    this.dialog.open(RelatedCompaniesFormTransactionsComponent, {
      // height: '50%',
      // width: '50%',
      data: { uid: uid, isContribution: isContribution, PartnerSelected: PartnerSelected },
    })
  }

  public openRelatedCompaniesT(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    let accountingAccount: RelatedCompaniesModel;
    for (let i = 0; i < this.dataSource.length; i++) {
      if (this.dataSource[i].uid === uid) {
        accountingAccount = this.dataSource[i];
      }
    }
    this.dialog.open(RelatedCompaniesDialogTComponent, {
      height: '80%',
      width: '80%',
      data: {
        uid: uid, accountingAccount: accountingAccount
      }
    });
  }

}
